import { FunctionComponent } from "react";
import SmartLink from "../controls/smart-link";
import { useTranslate } from "../../locales/hooks";

interface ISkillsChartProps {
  skills?: { name: string; width: string }[];
  headLabel?: string;
  headLink?: string;
  headLinkLabel?: string;
  size?: "small" | "medium" | "large";
}

const sizeClasses = {
  small: {
    skillText: "text-[5px]",
    headText: "text-[6px]",
    linkText: "text-[5px]",
  },
  medium: {
    skillText: "text-[10px]",
    headText: "text-[10px]",
    linkText: "text-[8px]",
  },
  large: {
    skillText: "text-[15px]",
    headText: "text-[14px]",
    linkText: "text-[12px]",
  },
} as const;

const SkillsChart: FunctionComponent<ISkillsChartProps> = (props) => {
  const t = useTranslate();

  const {
    skills = [],
    headLabel = t("headLabel__defaultText"),
    headLink,
    headLinkLabel = t("headLinkLabel__defaultText"),
    size = "medium",
  } = props;

  const classes = sizeClasses[size];

  return (
    <div className="relative flex w-full min-w-[200px] shrink-0 items-center justify-center">
      <div className="flex min-h-px min-w-px flex-[1_0_0] flex-col items-center justify-center gap-[2px]">
        {skills.map((skill, index) => (
          <div
            key={index}
            className="relative flex w-full shrink-0 items-start justify-end"
          >
            <div
              className="relative flex items-center justify-end rounded-bl-[10px] rounded-tl-[10px] bg-[#1e3a8a] transition-all duration-500 ease-out"
              style={{ width: skill.width }}
            >
              <div className="relative flex min-h-px min-w-px flex-[1_0_0] items-center justify-center py-[3px]">
                <div
                  className={`relative flex min-h-px min-w-px flex-[1_0_0] flex-col justify-center text-right font-['Manrope:Bold',sans-serif] font-bold leading-[0] text-[#f8fafc] ${classes.skillText}`}
                >
                  <p className="leading-[normal] whitespace-pre-wrap">
                    {skill.name}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex self-stretch">
        <div className="flex h-full w-full min-w-px shrink-0 items-center justify-center rounded-br-[100px] rounded-tr-[100px] bg-[#1e3a8a] px-[10px]">
          <div className="relative shrink-0 whitespace-nowrap text-center font-['Manrope:Bold',sans-serif] font-bold leading-[normal] text-[#f8fafc]">
            <p className={`mb-0 ${classes.headText}`}>{headLabel}</p>
            {headLink && (
              <SmartLink
                href={headLink}
                target="_blank"
                className={`decoration-solid underline ${classes.linkText}`}
              >
                {headLinkLabel}
              </SmartLink>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { SkillsChart };
export type { ISkillsChartProps };

